export const MIN_TOP_UP_RUBLES = 1;
export const MAX_TOP_UP_RUBLES = 100_000;
/** Whole rubles only. Bonus applies to the entire purchase, without compounding. */
export function calculateCreditTopUp(amountRubles) {
    if (!Number.isSafeInteger(amountRubles) ||
        amountRubles < MIN_TOP_UP_RUBLES ||
        amountRubles > MAX_TOP_UP_RUBLES) {
        throw new RangeError(`Сумма должна быть целым числом от ${MIN_TOP_UP_RUBLES} до ${MAX_TOP_UP_RUBLES} ₽`);
    }
    const bonusPercent = Math.min(20, Math.max(0, Math.floor(amountRubles / 100) - 1) * 2);
    const baseCredits = amountRubles * 10;
    const bonusCredits = Math.floor((baseCredits * bonusPercent) / 100);
    return {
        amountRubles,
        baseCredits,
        bonusPercent,
        bonusCredits,
        credits: baseCredits + bonusCredits,
    };
}
